import { RoutePaths } from '@interfaces/routePaths'
import { Base } from '@views/Calls/Base'
import { BaseLayout } from '../BaseLayout'

export const CALLS_PATHS = [
  {
    path: RoutePaths.CALLS,
    element: <BaseLayout />,
    children: [
      {
        index: true,
        element: <Base />,
      },
    ],
  },
]
